import { render } from "./AddEditProducts.vue?vue&type=template&id=e3de359c&scoped=true"
import script from "./AddEditProducts.vue?vue&type=script&lang=js"
export * from "./AddEditProducts.vue?vue&type=script&lang=js"

import "./AddEditProducts.vue?vue&type=style&index=0&id=e3de359c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3de359c"]])

export default __exports__